export default "__VITE_ASSET__Ds76JFR8__"